import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import MarkdownIt from 'markdown-it';
import { injectIntl, intlShape } from 'react-intl';

import { Message, User } from 'models';
import * as keyboardEventHelpers from 'globals/keyboardEvents';
import Avatar from 'shared/components/Avatar';

import { handleCampaignClick } from '../../../app/App/actions';
import { handleMarkChatSessionSeen } from '../../../chat/app/ChatApp/actions';
import { makeGetChatUserFromMessage } from '../../../chat/app/ChatApp/selectors';
import styles from './styles';
import messages from './messages';

const markdownRenderer = new MarkdownIt({ breaks: true });

export class IconMessagesMessage extends React.PureComponent {
  handleKeyPress = e => {
    const { onClick, sessionId } = this.props;

    if (keyboardEventHelpers.isEnterKey(e)) {
      e.preventDefault();
      e.stopPropagation();
      onClick(sessionId);
    }
  };

  handleDismissKeyPress = e => {
    const { onDismiss, sessionId } = this.props;

    if (keyboardEventHelpers.isEnterKey(e)) {
      e.preventDefault();
      e.stopPropagation();
      onDismiss(sessionId);
    }
  };

  handleClick = event => {
    const { onClick, sessionId } = this.props;
    event.preventDefault();
    event.stopPropagation();
    onClick(sessionId);
  };

  handleDismiss = event => {
    const { onDismiss, sessionId } = this.props;

    event.preventDefault();
    event.stopPropagation();
    onDismiss(sessionId);
  };

  renderCloseIcon() {
    const { intl } = this.props;

    return (
      <div
        tabIndex="0"
        onKeyPress={this.handleDismissKeyPress}
        role="button"
        aria-label={intl.formatMessage(messages.aria_label_close_button)}
        className="iconMessageClose"
        style={styles.close}
        onClick={this.handleDismiss}
      />
    );
  }

  renderBody() {
    const { message } = this.props;

    let safeMessage = message.body.replace(/(?:\r\n|\r|\n)/g, ' ');
    if (safeMessage && safeMessage.length > 140) {
      safeMessage = `${safeMessage.substring(0, 140)}...`;
    }

    return (
      <div
        style={styles.body}
        id="kustomerIconMessageBody"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: markdownRenderer.renderInline(safeMessage),
        }}
      />
    );
  }

  render() {
    const { user } = this.props;
    return (
      <div style={styles.container}>
        <div className="iconMessageAvatar" style={styles.avatar}>
          <Avatar avatarUrl={user.avatarUrl} defaultName={user.name} />
        </div>
        <div
          tabIndex="0"
          style={styles.message}
          onClick={this.handleClick}
          onKeyPress={this.handleKeyPress}
          role="button"
          aria-labelledby="kustomerIconMessageBody"
        >
          {this.renderCloseIcon()}
          {this.renderBody()}
        </div>
      </div>
    );
  }
}

IconMessagesMessage.propTypes = {
  message: PropTypes.instanceOf(Message),
  sessionId: PropTypes.string,
  user: PropTypes.instanceOf(User),
  onClick: PropTypes.func,
  onDismiss: PropTypes.func,
  intl: intlShape.isRequired,
};

IconMessagesMessage.defaultProps = {
  message: Message(),
  sessionId: null,
  user: User(),
  onClick: () => {},
  onDismiss: () => {},
};

const mapStateToProps = () => {
  const getChatUserFromMessage = makeGetChatUserFromMessage();
  return (state, props) => ({
    user: getChatUserFromMessage(state, props),
  });
};

export const mapDispatchToProps = dispatch => {
  return {
    onClick: sessionId => {
      dispatch(handleCampaignClick(sessionId));
    },
    onDismiss: sessionId => {
      if (sessionId) {
        dispatch(handleMarkChatSessionSeen(sessionId));
      }
    },
  };
};

export const componentWithIntl = injectIntl(IconMessagesMessage);
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(componentWithIntl);
